import { Injectable } from '@angular/core';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { RelatedSetLinkingModel } from '../models/relatedSetLinkingModel';
import { WebApiService } from 'starbase-login';
import { HttpClient } from '@angular/common/http';
import { RelatedSetModel } from '../models/relatedSetModel';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelatedSetService extends StarbaseDataService<RelatedSetModel> {
  protected _staleDataTimeout = 2000;
  protected _getOneUri: string;
  protected _getAllUri = '/api/RelatedImageSetModels';
  protected _postUri = '/api/RelatedImageSetModels';
  protected _putUri = '/api/RelatedImageSetModels/';
  protected _deleteUri = '/api/RelatedimageSetModels/DeleteRelatedImageSetModel';
  protected _broadSearchUri = '/api/RelatedImageSetModels/GetRelatedSetsBroadSearch';

  constructor(private _http: HttpClient, private _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<RelatedSetModel>):Observable<FilterParams<RelatedSetModel>> {
            return super.getDataByFilterParamsBroadSearch(url, filterParams).pipe(
              map((l) => {
                l.collection = l.collection.map((lu) =>  new RelatedSetModel().deserialize(lu));

                return l;
              })
            );
  }
}
